import React, { Component } from "react";
import "./EditProfile.css";

class EditProfile extends Component {
  constructor() {
    super();

    this.state = {
      name: "",
      phoneNumber: "",
      paymentRequestId: "",
      errors: {
        name: false
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const phoneNumber = localStorage.getItem("phoneNumber");
    const params = new URLSearchParams(this.props.location.search);
    const paymentRequestId = params.get("paymentRequestId");

    this.setState({ phoneNumber, paymentRequestId });
  }

  handleChange(event) {
    this.setState({ name: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const paymentRequestId = this.state.paymentRequestId;

    this.props.history.push(`solicitar/${paymentRequestId}`);
  }

  render() {
    const { name, phoneNumber, errors } = this.state;

    return (
      <div className="edit-profile">
        <h1 className="edit-profile-title">Mi perfil</h1>
        <div className="edit-profile-section">
          <div className="edit-profile-field">Número de teléfono</div>
          <div className="edit-profile-value">+{phoneNumber}</div>
        </div>
        <div className="edit-profile-section">
          <div className="edit-profile-field">Banco</div>
          <div className="edit-profile-value">
            Bancolombia<br />95112723032
          </div>
        </div>
        <div className="edit-profile-info-panel">
          Puedes cambiar tu cuenta bancaria y número de teléfono iniciando
          sesión en tu sitio web o aplicación de banca en línea.
        </div>
        <form
          className="edit-profile-form"
          action=""
          onSubmit={this.handleSubmit}
        >
          <label className="edit-profile-label" htmlFor="name">
            Nombre
          </label>
          <div className="edit-profile-input-hint">
            Otros usuarios pueden encontrar tu perfil con este nombre. Tu nombre
            es también visible en las solicitudes de dinero.
          </div>
          <input
            className="edit-profile-input"
            id="name"
            name="name"
            type="text"
            autoComplete="name"
            placeholder="Ingrese su nombre completo"
            value={name}
            onChange={this.handleChange}
            aria-invalid={errors.name}
          />
          <button
            className="edit-profile-submit button-green"
            onClick={this.handleSubmit}
          >
            Guardar
          </button>
        </form>
      </div>
    );
  }
}

export default EditProfile;



// WEBPACK FOOTER //
// ./src/EditProfile/EditProfile.js